import { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import { api } from '@/lib/api';
import { Trophy, Crown, Medal } from 'lucide-react';

export default function HallOfFame() {
  const [data, setData] = useState({ trophies: [], top_champions: [] });

  useEffect(() => {
    (async () => {
      const { data } = await api.get('/hall-of-fame');
      setData(data);
    })();
  }, []);

  return (
    <Layout>
      <div className="p-6 md:p-10 max-w-5xl">
        <div className="mb-10 rise text-center">
          <div className="overline text-orange-400 mb-2 flex items-center justify-center gap-2">
            <Trophy size={14} /> Salle des Champions
          </div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tight leading-none">
            Le hall of fame de <em className="not-italic text-orange-500">Maestro</em>
          </h1>
          <p className="text-stone-400 mt-4 max-w-xl mx-auto">
            Chaque semaine, un défi. Chaque semaine, un·e champion·ne. Voici toutes les légendes.
          </p>
        </div>

        {data.top_champions.length > 0 && (
          <section className="mb-12">
            <h2 className="font-display text-3xl mb-4 flex items-center gap-2">
              <Crown className="text-orange-400" /> Top 10 tous temps
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {data.top_champions.map((c, i) => (
                <div
                  key={c.user_id}
                  data-testid={`top-champion-${i}`}
                  className={`p-4 rounded-2xl border flex items-center gap-3 ${
                    i === 0 ? 'border-orange-800/60 bg-gradient-to-br from-orange-950/40 to-transparent' : 'border-stone-800 bg-stone-900/40'
                  }`}
                >
                  <div className={`w-10 font-display text-3xl ${i === 0 ? 'text-orange-400' : i === 1 ? 'text-stone-300' : i === 2 ? 'text-orange-700' : 'text-stone-500'}`}>#{i + 1}</div>
                  {c.user_picture ? (
                    <img src={c.user_picture} alt="" className="w-11 h-11 rounded-full" />
                  ) : (
                    <div className="w-11 h-11 rounded-full bg-stone-700 flex items-center justify-center">{c.user_name?.[0] || '?'}</div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-display text-xl truncate">{c.user_name}</div>
                    <div className="text-stone-400 text-sm">{c.wins} victoire{c.wins > 1 ? 's' : ''}</div>
                  </div>
                  {i === 0 && <Crown className="text-orange-400" />}
                </div>
              ))}
            </div>
          </section>
        )}

        <section>
          <h2 className="font-display text-3xl mb-4 flex items-center gap-2">
            <Medal className="text-orange-400" /> Tous les trophées
          </h2>
          {data.trophies.length === 0 ? (
            <div className="card-stone p-10 text-center text-stone-500">
              Personne n'a encore remporté de défi. Sois le premier à publier une reprise cette semaine !
            </div>
          ) : (
            <div className="space-y-3">
              {data.trophies.map((tr, i) => (
                <div key={tr.id} data-testid={`hof-trophy-${i}`} className="card-stone p-4 flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-orange-700 flex items-center justify-center shrink-0 shadow-lg shadow-orange-900/40">
                    <Trophy size={22} className="text-white" />
                  </div>
                  {tr.user_picture ? (
                    <img src={tr.user_picture} alt="" className="w-10 h-10 rounded-full" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-stone-700 flex items-center justify-center">{tr.user_name?.[0] || '?'}</div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-display text-lg">{tr.user_name}</div>
                    <div className="text-stone-400 text-sm truncate">Semaine {tr.week} · {tr.song_title} — {tr.song_artist}</div>
                  </div>
                  <div className="text-orange-400 font-medium">Score {tr.score}</div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </Layout>
  );
}
